import { useCallback, useEffect } from "react";
import { useUserStore } from "@/common/store/userStore";
import { isAuthenticated } from "@/common/services/Auth";
import { apiMe } from "@/common/services";
import { setUserData } from "@/common/utils/storage";

export const useGetUserData = () => {
  const setCurrentUser = useUserStore((state) => state.setCurrentUser);

  const fetchUserData = useCallback(async () => {
    const auth = await isAuthenticated();

    if (!auth) {
      setUserData(null);
      setCurrentUser(null);
      return;
    }

    try {
      const data = await apiMe.getMe();
      setCurrentUser(data);
      setUserData(data);
    } catch (e) {
      setCurrentUser(null);
    }
  }, []);

  useEffect(() => {
    fetchUserData();
  }, []);
};
